<div class="contents">
  <app-search-bar primaryBtnLabel="Novo Auxílio" (onPrimaryBtnClick)="callRouteCreateBolseiro()" [showFilterBtn]="true"
    (onFilterBtnClick)="showFilterModal()" (formValueChange)="handleFormValueChange($event)"
    class="ToTop"></app-search-bar>

  <div class="row">
    <ng-container *ngIf="pagination.data?.length; else emptyTemplate">
      <app-table [pagination]="pagination" [columns]="columns" [actions]="actions" (pageChange)="onPageChange($event)"
        (actionSelected)="onActionSelected($event)" (rowClick)="callRouteEditBolsa($event)"></app-table>

      <!-- Drawer de Documentos -->
      <p-drawer [(visible)]="showDocs" position="right" [style]="{'width': '720px'}"
        styleClass="!w-full md:!w-80 lg:!w-[30rem]">
        <ng-template #headless>
          <app-doc-anexo-drawer [estudanteSelected]="selectedBolsa?.bolseiro" (onCloseModal)="showDocs=false"
            *ngIf="selectedBolsa" [entidadeId]="selectedBolsa?.id" [estudanteNome]="selectedBolsa?.bolseiro?.nome"
            [numeroBI]="selectedBolsa?.bolseiro?.numeroBI">
          </app-doc-anexo-drawer>
        </ng-template>
      </p-drawer>

    </ng-container>
    <ng-template #emptyTemplate>
      <div class="no-data">
        <app-data-void titulo="Nenhuma bolsa encontrada"
          descricao="Clique em adicionar bolsa para criar uma."></app-data-void>
      </div>
    </ng-template>
  </div>

</div>

<p-toast></p-toast>
<p-confirmdialog></p-confirmdialog>

<!-- Dialog de Filtros -->
<p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">
  <form [formGroup]="form" class="p-fluid grid">
    <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <label>{{ filter.placeholder }}</label>
      <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
        [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
        [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
      </p-select>
      <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder" class="w-full" />
    </div>
  </form>
  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
    <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
  </div>
</p-dialog>

<!-- Dialog de Alterar Estado -->
<p-dialog header="Alterar Estado da Bolsa" [modal]="true" [(visible)]="showAlterarEstado" [style]="{ width: '36rem' }"
  appendTo="body" (onHide)="alterarEstadoForm.reset()">
  <form [formGroup]="alterarEstadoForm" class="p-fluid grid">
    <div class="field col-12 d-flex flex-column">
      <label>Estado da Bolsa <span class="p-error">*</span></label>
      <p-select [filter]="true" [showClear]="true" appendTo="body" [options]="estados" formControlName="estadoBolsa"
        placeholder="Seleccione o estado" optionLabel="label" optionValue="id"></p-select>
      <small class="p-error"
        *ngIf="alterarEstadoForm.get('estadoBolsa')?.invalid && alterarEstadoForm.get('estadoBolsa')?.touched">
        O estado é obrigatório.
      </small>
    </div>
    <div class="field col-12 d-flex flex-column">
      <label>Observação / Motivo <span class="p-error">*</span></label>
      <textarea pTextarea formControlName="observacao" rows="4" placeholder="Descreva o motivo da alteração..."
        class="w-full"></textarea>
      <small class="p-error"
        *ngIf="alterarEstadoForm.get('observacao')?.invalid && alterarEstadoForm.get('observacao')?.touched">
        A observação é obrigatória.
      </small>
    </div>
  </form>
  <div class="flex items-center justify-content-between mt-2">
    <p-button label="Cancelar" severity="secondary" (click)="showAlterarEstado = false" />
    <p-button label="Confirmar" icon="pi pi-check" (click)="submitAlterarEstado()" />
  </div>
</p-dialog>

<!-- Drawer de Lançar Notas -->
<p-drawer [(visible)]="drawerNotasVisible" position="right" [style]="{ width: '660px' }" [showCloseIcon]="false"
  styleClass="notas-drawer">
  <ng-template #headless>
    <app-lancar-notas *ngIf="drawerNotasVisible && selectedBolsaParaNotas"
      [matriculaId]="selectedBolsaParaNotas?.matricula?.[0]?.id"
      [matriculas]="selectedBolsaParaNotas?.matricula || []"
      [anoCurricular]="selectedBolsaParaNotas?.matricula?.[0]?.anoCurricular"
      [anoLectivo]="selectedBolsaParaNotas?.matricula?.[0]?.anoLectivo?.ano"
      [bolseiroNome]="selectedBolsaParaNotas?.bolseiro?.nome" [curso]="selectedBolsaParaNotas?.matricula?.[0]?.curso"
      [instituicao]="selectedBolsaParaNotas?.matricula?.[0]?.instituicaoEnsino" [bolsaId]="selectedBolsaParaNotas?.id"
      (fechar)="drawerNotasVisible = false"></app-lancar-notas>
  </ng-template>
</p-drawer>